import type { ComponentProps } from "react";
import { cn, Card as BricksCard } from "@boligportal/bricks-ui";

export const Card = ({
  className,
  ...props
}: ComponentProps<typeof BricksCard.Root>) => {
  return (
    <BricksCard.Root
      className={cn("rounded-lg", className)}
      {...props}
    />
  );
};

Card.Content = BricksCard.Content;
Card.Header = BricksCard.Header;
Card.Title = BricksCard.Title;
Card.Description = BricksCard.Description;
Card.Action = BricksCard.Action;
Card.Footer = BricksCard.Footer;
